export enum REMOTE_DATA_STATUS {
  NOT_ASKED = 'NotAsked',
  LOADING = 'Loading',
  FAILURE = 'Failure',
  SUCCESS = 'Success',
}

export type NotAsked = { readonly type: REMOTE_DATA_STATUS.NOT_ASKED };

export type Loading = { readonly type: REMOTE_DATA_STATUS.LOADING };

export type Failure<E> = {
  readonly type: REMOTE_DATA_STATUS.FAILURE;
  error: E;
};

export type Success<D> = { readonly type: REMOTE_DATA_STATUS.SUCCESS; data: D };

export type RemoteData<E, D> = NotAsked | Loading | Failure<E> | Success<D>;
